const suggestionDb = require('./suggestion-db')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function init(detail) {
    bestItemsTable(detail)
    bestProviderItemTable(detail)
    bestCustomerItemTable(detail)

    const cont = document.querySelector('#suggestion-page .title');
    const date = new Date();
    const monthName = date.toLocaleString('en-US', { month: 'long' });
    cont.innerHTML = ""
    cont.innerHTML = `Items history on ${monthName}`
    return
}

function bestItemsTable() {
    suggestionDb.load(
        { 'file': 'item_best_ten' },
        (result) => {
            const bestColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, bestColumns);

            const lowerColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, lowerColumns);

            const cont = document.querySelector('#suggestion-item-last-movements');
            cont.innerHTML = ""
            cont.innerHTML = bestTable

            const cont2 = document.querySelector('#suggestion-item-lower-movements');
            cont2.innerHTML = ""
            cont2.innerHTML = lowerTable
            return
        }
    )

}

function bestProviderItemTable() {
    suggestionDb.load(
        { 'file': 'provider_item_best_ten' },
        (result) => {
            const bestColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, bestColumns);

            const lowerColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },

            ];

            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, lowerColumns);

            const cont = document.querySelector('#suggestion-provider-item-last-movements');
            cont.innerHTML = ""
            cont.innerHTML = bestTable

            const cont2 = document.querySelector('#suggestion-provider-item-lower-movements');
            cont2.innerHTML = ""
            cont2.innerHTML = lowerTable
            return
        }
    )
}

function bestCustomerItemTable() {
    suggestionDb.load(
        { 'file': 'customer_item_best_ten' },
        (result) => {
            const bestColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'customer_name', label: 'Customer', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, bestColumns);

            const lowerColumns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'customer_name', label: 'Customer', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                // star
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                // star
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, lowerColumns);

            const cont = document.querySelector('#suggestion-customer-item-last-movements');
            cont.innerHTML = ""
            cont.innerHTML = bestTable

            const cont2 = document.querySelector('#suggestion-customer-item-lower-movements');
            cont2.innerHTML = ""
            cont2.innerHTML = lowerTable
            return
        }
    )
}